import {
  GET_INVITATION_DATA_FAILURE,
  GET_INVITATION_DATA_REQUEST,
  GET_INVITATION_DATA_SUCCESS,
} from "features/friend-refer/redux/types";
import { setInvitationHash } from "screens/shared-event/utils/eventsStorageUtils";

const INITIAL_STATE = {
  data: null,
  isLoading: false,
  errors: null,
};

export const friendReferReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_INVITATION_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: null,
      };
    case GET_INVITATION_DATA_SUCCESS:
      setInvitationHash(action.payload.data.referral_hash);
      return {
        ...state,
        data: action.payload.data,
        isLoading: false,
      };
    case GET_INVITATION_DATA_FAILURE:
      return {
        ...state,
        errors: action.error,
      };

    default:
      return state;
  }
};
